import Logger from '@utils/log'

// eslint-disable-next-line no-unused-vars
const log = new Logger('utils/canvas')

// @todo this corresponds to the PDF rendering library, need to consolidate into config
export const scaleAmount = 1.0

export const highlightOpacity = 0.4
export const highlightFillStyle = `rgba(245, 245, 0, ${highlightOpacity})`
export const highlightStrokeStyle = `rgba(225, 225, 0, ${highlightOpacity})`
export const highlightTextFillStyle = 'rgba(34,34,34, 1.0)'

export const highlightPaddingPx = 10

/**
 * Initializes canvases for search highlighting
 * by setting scale factor & dimensions
 * 
 * @param {HTMLCanvasElement} sourceCanvas Source canvas where the PDF document is rendered
 * @param {...HTMLCanvasElement} canvases Other canvases for rendering overlays & the final output
 */
export const initSearchResultCanvases = (sourceCanvas, ...canvases) => {
    
    sourceCanvas.getContext('2d').scale(scaleAmount, scaleAmount)
    
    // Resize main canvas & overlays off-screen canvas to match document
    // off-screen canvas, which is auto-sized by the PDF renderer to the PDF dimensions
    canvases.forEach(it => {
        it.getContext('2d').scale(scaleAmount, scaleAmount)
        it.width = sourceCanvas.width
        it.height = sourceCanvas.height
    })
    
}

/**
 * Renders a search result overlay over a PDF using canvas
 *
 * @param {HTMLCanvasElement} renderCanvas - The rendering canvas context
 * @param {HTMLCanvasElement} overlaysCanvas - The overlays canvas context
 * @param {HTMLCanvasElement} documentCanvas - The document canvas context
 * @param {AnnotationResult} result - The search result object
 * @param {Object} options - Additional rendering options
 * @param {boolean} [options.debug=false] - Whether to enable debug mode
 * @param {string} [options.fillStyle=highlightFillStyle] - The fill style for highlights
 * @param {string} [options.strokeStyle=highlightStrokeStyle] - The stroke style for highlights
 * @param {string} [options.textFillStyle=highlightTextFillStyle] - The text fill style for highlights
 * @param {boolean} [options.withText=false] - Whether to include text in the overlay
 */
export const renderSearchResultOverlay = (
    renderCanvas,
    overlaysCanvas,
    documentCanvas,
    result,
    {
        debug = false,
        fillStyle = highlightFillStyle,
        strokeStyle = highlightStrokeStyle,
        textFillStyle = highlightTextFillStyle,
        withText = false,
    } = {},
) => {
    
    if (!result.original_width || !result.original_height)
        throw new Error('Result is missing "original_width" & "original_height" properties')
    
    const { value } = result
    const context = renderCanvas.getContext('2d')
    
    const originalWidth = result.original_width
    const originalHeight = result.original_height
    const renderSize = {
        width: renderCanvas.width,
        height: renderCanvas.height,
    }
    
    const scaleX = renderSize.width / originalWidth
    const scaleY = renderSize.height / originalHeight
    
    const x = value.x * scaleX - (highlightPaddingPx / 2)
    const y = value.y * scaleY - (highlightPaddingPx / 2)
    const width = value.width * scaleX + highlightPaddingPx
    const height = value.height * scaleY + highlightPaddingPx
    
    context.fillStyle = fillStyle
    context.fillRect(x, y, width, height)
    
    context.lineWidth = 2
    context.strokeStyle = strokeStyle
    context.strokeRect(x, y, width, height)
    
    // ----------------------------------------------------
    // everything below here is just test/debug code
    // ----------------------------------------------------
    
    if (debug) {
        
        console.log('canvas renderSearchResultOverlay', {
            value,
            originalWidth,
            originalHeight,
            renderSize,
            scaleX,
            scaleY,
            // originX,
            // originY,
            x,
            y,
            width,
            height,
        })
        
        /* console.log('canvas renderSearchResultOverlay', {
            x,
            y,
            width,
            height,
            text: value.text?.join(' '),
        }) */
        
        context.font = '32px monospace'
        
        // Constant/control box
        context.fillStyle = 'rgba(250, 60, 190, 1.0)'
        context.fillRect(10, 10, 150, 75)
        context.fillStyle = 'black'
        context.fillText('CONTROL', 20, 55)
        context.fillText(`Search Term: "${value.text.join(' ')}"`, 175, 55)
        
        context.strokeStyle = 'rgba(0, 0, 255, 1.0)'
        context.strokeRect(x - 1, y - 1, width, height)
        context.strokeRect(x + 1, y + 1, width, height)
        context.strokeRect(x + 2, y + 2, width, height)
        
        const debugBBoxFactor = 4
        const debugBBox = {
            x: x / debugBBoxFactor,
            y: y / debugBBoxFactor,
            width: width / debugBBoxFactor,
            height: height / debugBBoxFactor,
        }
        
        console.log('canvas renderSearchResultOverlay (debug box)', {
            ...debugBBox,
            text: value.text?.join(' '),
        })
        
        context.fillStyle = 'rgba(255, 0, 0, 0.65)'
        context.fillRect(debugBBox.x, debugBBox.y, debugBBox.width, debugBBox.height)
        context.fillStyle = 'black'
        context.fillText('DBG BOX', debugBBox.x + 20, debugBBox.y + 50)
        
    }
    
    if (withText) {
        context.font = '17px Arial'
        context.fillStyle = textFillStyle
        context.fillText(value.text.join(' '), x, y + height)
    }
    
}
